import { put, select, spawn, delay } from 'redux-saga/effects';
import { CalendarEvent, PlanTasksRequest } from 'shovel-lib/types';

import * as actions from './actions';
import * as semesterSelectors from '../semester/selectors';
import { apiCall } from '../common/operations';
import { getErrorMessage } from '../../api/network';
import { plannerApi } from '../../api/plannerApi';
import { actionIdOf } from '../../api/activityLogApi';

// Apart from the calendar's sagas so that creating a task (task/operations) can call it: the calendar's sagas import the
// task module, and importing them back would make a loop.

/**
 * Saves sessions (the Plan dialog's, or one for a task just created on the calendar), puts them on the calendar and
 * returns them with the change's id for Undo; null when the save failed. Called rather than dispatched, so creating a
 * task can plan its session without another planning action cancelling either. `actionId`: the task's creation, so the
 * session is part of the same change.
 */
export function* planSessions(blocks: PlanTasksRequest, actionId?: string) {
  const semesterId = yield select(semesterSelectors.getId);
  const { ok, ...response } = yield apiCall(plannerApi.planBulk, semesterId, blocks, actionId);
  if (!ok) {
    yield put(actions.planTasks.failure(getErrorMessage(response)));
    return null;
  }
  yield put(actions.planTasks.success(response.data));
  yield put(actions.closePlanBlockDialog());
  const plannedTaskIds = response.data.map((task: any) => task.id);
  yield put(actions.highlightAiPlannedTasks(plannedTaskIds));
  // Spawned: the highlight goes even if whoever planned is cancelled by a newer action.
  yield spawn(clearHighlightLater, plannedTaskIds);
  return { planned: response.data as CalendarEvent[], actionId: actionId ?? actionIdOf(response) };
}

export function* clearHighlightLater(plannedTaskIds: number[], afterMs = 3000) {
  yield delay(afterMs);
  yield put(actions.clearAiPlannedTasksHighlight(plannedTaskIds));
}
